// Détection automatique du statut d'un abonnement KotosShop.
// NB: ceci calcule et AFFICHE le statut (essai / actif / en retard / suspendu)
// à partir des dates stockées sur la commande. La coupure réelle et automatique
// d'un service (au sens "couper l'accès à minuit sans intervention humaine")
// nécessiterait une tâche planifiée côté serveur (ex: Firebase Cloud Function
// + cron), absente de ce projet React pur. Ce module prépare les données et
// l'admin confirme la suspension en un clic — prêt à être branché sur une
// Cloud Function plus tard si besoin.

const DAY = 24 * 60 * 60 * 1000;
const GRACE_DAYS_DEFAUT = 3; // valeur par défaut si non configuré dans Admin

export function computeSubscriptionStatus(commande, graceDays = GRACE_DAYS_DEFAUT) {
  if (!commande?.abonnement) return null;

  if (commande.statutAbonnement === 'suspendu') {
    return { statut: 'suspendu', label: '⛔ Suspendu', color: '#FF4060' };
  }

  const now = Date.now();
  const prochain = commande.dateProchainPaiement ? new Date(commande.dateProchainPaiement).getTime() : null;
  if (!prochain) return { statut: 'inconnu', label: '❔ Non calculé', color: 'var(--muted)' };

  const joursRestants = Math.ceil((prochain - now) / DAY);

  if (commande.statutAbonnement === 'essai' && now < prochain) {
    return { statut: 'essai', label: `🎁 Essai gratuit (${joursRestants} j restants)`, color: '#00BFFF', joursRestants };
  }
  if (now <= prochain) {
    return { statut: 'actif', label: `✅ Actif (${joursRestants} j avant échéance)`, color: '#00CC88', joursRestants };
  }
  const joursRetard = Math.floor((now - prochain) / DAY);
  if (joursRetard <= graceDays) {
    return { statut: 'grace', label: `⏳ Échéance dépassée (${joursRetard} j, délai de grâce)`, color: '#D4A017', joursRetard };
  }
  return { statut: 'en_retard', label: `🔴 Impayé — ${joursRetard} j de retard`, color: '#FF4060', joursRetard };
}

export function addDays(dateStr, days) {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return d.toISOString().split('T')[0];
}

// Construit les champs d'abonnement à enregistrer sur une commande, à partir
// des produits du panier (si au moins un produit "abonnement" est présent).
export function buildAbonnementFields(cartItems, produits, todayStr) {
  const abonnementItem = cartItems.find(it => {
    const p = produits.find(pp => pp.id === it.id);
    return p?.types?.abonnement;
  });
  if (!abonnementItem) return {};

  const p = produits.find(pp => pp.id === abonnementItem.id);
  const essai = !!p.essaiGratuit;
  const jours = essai ? (p.essaiGratuitJours ?? 30) : 30;

  return {
    abonnement: true,
    essaiGratuit: essai,
    dateDebut: todayStr,
    dateProchainPaiement: addDays(todayStr, jours),
    statutAbonnement: essai ? 'essai' : 'actif',
  };
}
